import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, materialize, dematerialize } from 'rxjs/operators';

// array in local storage for registered datas
let datas = JSON.parse(localStorage.getItem('datas')) || [];

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const { url, method, headers, body } = request;

        // wrap in delayed observable to simulate server api call
        return of(null)
            .pipe(mergeMap(handleRoute))
            .pipe(materialize()) // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
            .pipe(delay(500))
            .pipe(dematerialize());

        function handleRoute() {
            switch (true) {
                case url.endsWith('/datas/authenticate') && method === 'POST':
                    return authenticate();
                case url.endsWith('https://www.elchef.app/client/v1/register') && method === 'POST':
                    return register();
                case url.endsWith('/datas') && method === 'GET':
                    return getdatas();
                case url.match(/\/datas\/\d+$/) && method === 'DELETE':
                    return deletedata();
                default:
                    // pass through any requests not handled above
                    return next.handle(request);
            }    
        }

        // route functions

        function authenticate() {
            const { email, password } = body;
            const data = datas.find(x => x.email === email && x.password === password);
            if (!data) return error('Email or password is incorrect');
            return ok({
                id: data.id,
                email: data.email,
                name: data.name,
                mobile: data.mobile,
                address: data.address,
                token: 'fake-jwt-token'
            })
        }

        function register() {
            const data = body

            if (datas.find(x => x.email === data.email)) {
                return error('Email "' + data.email + '" is already taken')
            }

            data.id = datas.length ? Math.max(...datas.map(x => x.id)) + 1 : 1;
            datas.push(data);
            localStorage.setItem('datas', JSON.stringify(datas));

            return ok();
        }

        function getdatas() {
            if (!isLoggedIn()) return unauthorized();
            return ok(datas);
        }

        function deletedata() {
            if (!isLoggedIn()) return unauthorized();

            datas = datas.filter(x => x.id !== idFromUrl());
            localStorage.setItem('datas', JSON.stringify(datas));
            return ok();
        }

        // helper functions

        function ok(body?) {
            return of(new HttpResponse({ status: 200, body }))
        }

        function error(message) {
            return throwError({ error: { message } });
        }

        function unauthorized() {
            return throwError({ status: 401, error: { message: 'Unauthorised' } });
        }

        function isLoggedIn() {
            return headers.get('Authorization') === 'Bearer fake-jwt-token';
        }

        function idFromUrl() {
            const urlParts = url.split('/');
            return parseInt(urlParts[urlParts.length - 1]);
        }
    }
}

export const fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: HTTP_INTERCEPTORS,
    useClass: FakeBackendInterceptor,
    multi: true
};